import { frontendURL } from 'dashboard/helper/URLHelper.js';
import BriefingAgentPage from './pages/BriefingAgentPage.vue';

// Internal tool — available to every signed-in team member.
const meta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

const briefingRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/briefing/:agent'),
      name: 'briefing_agent',
      meta,
      component: BriefingAgentPage,
      props: true,
    },
  ],
};

export default briefingRoutes;
